import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Modal from '@material-ui/core/Modal'
import BlacklistedForm from './BlacklistedForm'
import useBlacklistedStore from '../../stores/BlacklistedStore'
import CustomTable from '../customTable/CustomTable'
import { useHistory } from 'react-router-dom'
import ListHeader from '../common/ListHeader'
import { formatCI } from '../common/ShowImageTable'

export default function BlacklistedList({ building }) {
  const [modalOpen, setModalOpen] = useState(false)
  const state = useBlacklistedStore((state) => state)
  const getBlacklisted = state.fetchBlacklisted
  const deleteBlacklisted = state.deleteBlacklistedItem
  const history = useHistory()

  const options = (blacklisted) => [
    {
      key: 'edit',
      label: 'Editar',
      onClick: () => {
        history.push('nuevo-restringido', { blacklisted })
      },
    },
    {
      key: 'delete',
      label: 'Eliminar',
      onClick: () => {
        deleteBlacklisted(blacklisted.id)
      },
    },
  ]

  const columns = [
    {
      id: 'ci',
      label: 'Documento de identidad',
      minWidth: 100,
      format: (value) => formatCI(value.ci),
    },
    { id: 'name', label: 'Nombre', minWidth: 170 },
    { id: 'observation', label: 'Observaciones', minWidth: 170 },
    !building && {
      id: 'building',
      label: 'Cliente',
      minWidth: 170,
      format: (value) => value.building.name,
    },
    {
      id: 'createdAt',
      label: 'Fecha',
      minWidth: 170,
      format: (value) => new Date(value.createdAt).toLocaleString('es'),
    },
    {
      id: '',
      label: '',
      minWidth: 5,
    },
  ]

  const blacklisted = state?.blacklisted || []
  return (
    <>
      <ListHeader
        bigTitle="Restringidos"
        createText="Nuevo restringido"
        createRedirect={() => history.push('/nuevo-restringido')}
      />
      <CustomTable
        loading={state.isLoading}
        columns={columns}
        data={blacklisted || []}
        getData={(params) => getBlacklisted({ ...params })}
        buildingFilter={!building}
        building={building}
        apartmentFilter={false}
        searchTitle={'Nombre, apellido o documento de identidad'}
        searchPlaceholder={
          'Ingrese un nombre, apellido o documento de identidad'
        }
        options={options}
        serverPagination={true}
        serverCount={state?.count}
      ></CustomTable>
      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="simple-modal-title"
      >
        <BlacklistedForm
          closeModal={() => setModalOpen(false)}
          handleCancel={() => setModalOpen(false)}
          building={building}
        />
      </Modal>
    </>
  )
}
